var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJewelry2 = function SvgJewelry2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.266 1.503 8.001 4.41l2.734-2.906zm6.731.847L9.735 4.753h4.031zm1.563 3.903H2.44l5.56 6.134zm-11.325-1.5h4.031L4.004 2.35zm13.572 1.253-7.25 8a.75.75 0 0 1-1.113 0l-7.25-8a.75.75 0 0 1-.047-.95l3.5-4.75A.75.75 0 0 1 4.25 0h7.5c.238 0 .463.113.604.306l3.5 4.75a.754.754 0 0 1-.047.95"
  })));
};
export default SvgJewelry2;